import { createStore } from "vuex";
// import { SideMenuStore } from "./module/SideMenuStore";
// import { AccountStore } from "./module/AccountStore.js";
import { PageTransition } from "./PageTransition/PageTransition.js";

export default createStore({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        // sideMenu: SideMenuStore,
        // account: AccountStore,
        transition: PageTransition,
    }
});
